var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: _vm.btnClasses,
      attrs: { disabled: _vm.isDisabled },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.doClick.apply(null, arguments)
        },
      },
    },
    [
      _vm.isLoading
        ? _c("span", [
            _c(
              "svg",
              {
                staticStyle: { "enable-background": "new 0 0 50 50" },
                attrs: {
                  version: "1.1",
                  id: "loader-1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  x: "0px",
                  y: "0px",
                  width: "20px",
                  height: "20px",
                  viewBox: "0 0 50 50",
                  "xml:space": "preserve",
                },
              },
              [
                _c(
                  "path",
                  {
                    attrs: {
                      fill: "currentColor",
                      d: "M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z",
                    },
                  },
                  [
                    _c("animateTransform", {
                      attrs: {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 25 25",
                        to: "360 25 25",
                        dur: "0.6s",
                        repeatCount: "indefinite",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        [
          !_vm.isLoading && !_vm.isSuccess && !_vm.isError
            ? _vm._t("default", function () {
                return [_vm._v(_vm._s(_vm.$t("save")))]
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("span", [
            _vm._v(
              _vm._s(_vm.textLoading ? _vm.textLoading : _vm.$t("saving"))
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSuccess
        ? _c("span", [
            _vm._v(
              _vm._s(_vm.textIsSuccess ? _vm.textIsSuccess : _vm.$t("saved")) +
                "!"
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isError ? _c("span", [_vm._v(_vm._s(_vm.$t("error")))]) : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }